import { render } from "./DashboardData.vue?vue&type=template&id=19a8af3c&scoped=true"
import script from "./DashboardData.vue?vue&type=script&lang=js"
export * from "./DashboardData.vue?vue&type=script&lang=js"

import "./DashboardData.vue?vue&type=style&index=0&id=19a8af3c&lang=scss&scoped=true"

import exportComponent from "/root/workspace/apm-rma-frontend_iTfK/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19a8af3c"]])

export default __exports__